/**
 * Short, thoughtful pitch bullets for a deal brief. Uses only the caller's own
 * listings the counterparty viewed — names, form and price, never a source.
 */
export interface ViewedListing {
  listing_id: string;
  name: string | null;
  product_form: string | null;
  price_per_gram: number | null;
  views: number;
  last_viewed_at: string;
}

const MAX_BULLETS = 3;

const priceLb = (ppg: number | null) =>
  ppg && ppg > 0 ? `$${Math.round(ppg * 453.592).toLocaleString('en-US')}/lb` : null;

export function pitchBullets(viewed: ViewedListing[], counterpartyName?: string | null): string[] {
  const named = viewed.filter((v) => v.name && v.name.trim());
  if (named.length === 0) return [];
  const bullets = named.slice(0, MAX_BULLETS).map((v) => {
    const bits = [v.name!.trim(), v.product_form, priceLb(v.price_per_gram)].filter(Boolean);
    const interest = v.views > 1 ? ` — looked ${v.views} times` : '';
    return `${bits.join(' · ')}${interest}`;
  });
  const who = counterpartyName?.trim() ? `${counterpartyName.trim()} has` : 'They have';
  return [`${who} been looking at:`, ...bullets.map((b) => `• ${b}`)];
}
